<article>
  <h2>{{post.title}}</h2>
  <p>{{post.text}}</p>
  <a [attr.href]="post.link">Read full article</a>
</article>
